<template>
    <ul>
        <div v-for="(index, val) in item" :key="val">
            <li @click="myFunction(index)">{{ index.label }}</li>
            <CCustomUl v-if="index.childs && index.childs.length > 0" :item="index.childs" @customUl="val => $emit('customUl', val)"/>
        </div>
    </ul>
</template>

<script>
import CCustomUl from './CCustomUl'

export default {
    name: 'CCustomUl',

    components: {
        CCustomUl,
    },

    props: {
        item: {
            default() {
                return {
                }
            },
            type: Array
        }
    },

    methods: {
        myFunction(item) {
            this.$emit('customUl', item)
        }
    }
}
</script>